 


<template>
	<div class="about-xs" style="position:relative;">

		<div class="aw-register-box about-box">
			<div class="mod-body clearfix gxgd">
				<div class="content   aboutx">
					<h1 style="color: #2d8cf0;">1.2、什么是数据库</h1>
					<div class="about-t">
					&nbsp; &nbsp;&nbsp; &nbsp;学习sql之前不得不先知道什么是数据库？
					</div>
					<h2 class="about-cs">1.2.1、数据库存什么？</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; 数据库是存放数据的地方，好比每家里都会有冰箱，冰箱是用来存什么的？冰箱是用来存放食物的地方。<br> 
					</div>
					<h2 class="about-cs">1.2.2、数据库是如何存放数据的？</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp;  数据库有很多种类，这里我们重点学习使用最广泛的关系数据库。关系数据库是由多个表组成的。如果你用过Excel，就会知道Excel是一张一张的二维表。每个表都是由行和列组成的。同样的，关系数据库里存放的也是一张一张的表，只不过各个表之间是有联系的。所以，简单来说：关系数据库=多张表+各表之间的关系。</br> 
					    &nbsp; &nbsp;&nbsp; &nbsp; （1）表的结构</br>
						&nbsp; &nbsp;&nbsp; &nbsp; 每个表由一个名字标识，表包含带有列名的列，和记录数据的行。我们举个具体的例子就一目了然了。下面图片里的表名是：学生表，记录了每个学生的信息。 </br>
					    <img :src="require('@/assets/image/demo/introduce1.png')"style="height: 280px;width: 50%;"> </br>
						&nbsp; &nbsp;&nbsp; &nbsp;表中每一列都有一个名字来标识出该列，这个表里有4列，列名分别是学号，姓名，出生日期，性别。从列名上你也可以知道这一列对应记录的是什么数据。表的每一行里记录着数据。这里的一行表示该名学生的信息，比如第2行是学号0002学生的信息，他的姓名是猴子，出生日期是1990-12-21，性别是女。</br>
					    &nbsp; &nbsp;&nbsp; &nbsp; （2）各表之间的关系</br>
					    &nbsp; &nbsp;&nbsp; &nbsp; 关系数据库是由多张表组成的，图片里是存放在学校数据库里的4张表。你能发现下面这4张表之间有什么关系吗？ </br>
					    <img :src="require('@/assets/image/demo/introduce2.png')"style="height: 280px;width: 50%;"> </br>
					    &nbsp; &nbsp;&nbsp; &nbsp;什么是关系呢？你是你爸爸的儿子，你是你的儿子的爸爸，这就是生活中的关系。其实，数据之间也是有关系的。关系数据库里各个表之间如何建立起关系呢？</br>
					    &nbsp; &nbsp;&nbsp; &nbsp;学生表和成绩表这两张表通过”学号”关联起来。例如：我想知道学生表里学号“0001” 的成绩是多少？那么我就可以在成绩表里去查找“学号”值是0001的行，最后在成绩表里发现有3行数据的学号都是“0001” ，对应的就找到了该学生的三门课程的成绩。
					</div>
					 
					 
				</div>
			</div>
		</div>
	</div>
</template>


 <script>
 	 
 	export default {
 		components: {
 			 
 		},
 
 		data() {
 			return {
  
 			}
 		},
 
 		 
 		methods: {
 
 			showNote() {
 				 
 					this.$Message.info('介绍在线编辑器！');
 				 
 			}
 
 		},
 
 	}
 </script>

<style lang="scss"  scoped>
	#vip{
		color: red;
		
	}
	
	.about-xs {
		
		margin-bottom: 20px;
		margin-top: 10px;
		margin: 20px;
	}

	//标题字体
  .content h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}

	//内容字体	
  .content .about-t {
		width: 1040px;
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 18px;
		line-height: 60px;
	}


	.aw-register-box .mod-body .content .about-t .at-r {
		width: 596px;
		height: auto;
		float: right;
		text-align: center;
	}

	.aw-register-box .mod-body {
		padding: 10px 10px 10px 10px;
	}

	.aw-register-box .gxgd {
		padding: 10px 10px 10px 10px;
	}


	.about-box {
		width: 1170px;
		margin: 10px;
		background-color: #fff;
		border-radius: 0;
		-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
	}




	.aw-register-box .mod-body .content .about-t .at-l {
		width: 442px;
		height: auto;
		padding-top: 80px;
		float: left;
		text-align: left;
	}

	.aw-register-box .mod-body .content .about-t .at-l2 {
		width: 496px;
		height: auto;
		float: left;
		text-align: center;
	}

	.aw-register-box .mod-body .content h2.about-cs font {
		color: #e37626;
		font-size: 24px;
	}

	.aw-register-box .mod-bodyx .content h2 {
		margin: 0 0 13px 0;
		color: #333;
		font-size: 18px;
	}

	.aw-register-box .mod-body .content h2.t-center {
		text-align: center;
	}
 
	.aw-register-box .mod-body .mod-bodyt h2.t-center {
		text-align: center;
	}
</style>
